@if (errorMessage()) {
  <div class="errorMessage">
    {{ errorMessage() }}
  </div>
}
<app-sureflow-loop-designer [selectedLoopId]="selectedLoopId()" [loops]="loops()" (addRequested)="addLoop($event)"
  (deleteRequested)="deleteLoop($event)" (addLoopUnit)="addUnit($event)"
  [selectedUnitIds]="selectedUnitIds()"
  (loopSelected)="changeSelectedLoopId($event)" [units]="selectedLoopUnits()"
  (selectedUnitsChanged)="unitSelectionChanged($event)"
  (deleteLoopUnits)="deleteLoopUnits()" (copyUnits)="copyLoopUnits()"
  (editSelectedUnits)="editUnits()" (addNonSureFlowUnit)="addNonSureFlowUnit($event)"
  (loopRecalculated)="updateAndRecalculateLoop($event)" (autoSelect)="autoSelectUnits($event)"
  (unitsRearranged)="rearrangeUnits($event)" (loopCopied)="copyLoop($event)"
  (addLoopsToSchedule)="addLoopsToSchedule()"
  (loopDescriptionChanged)="saveLoopDescription($event)"
  [showCreateScheduleButton]="true">
</app-sureflow-loop-designer>
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
